/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Link_Target_NavigationiframeInputs */

const en_enum_link_target_navigationiframe = /** @type {(inputs: Enum_Link_Target_NavigationiframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show as iFrame in navigation`)
};

const de_enum_link_target_navigationiframe = /** @type {(inputs: Enum_Link_Target_NavigationiframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als iFrame in der Navigation anzeigen`)
};

/**
* | output |
* | --- |
* | "Show as iFrame in navigation" |
*
* @param {Enum_Link_Target_NavigationiframeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_link_target_navigationiframe = /** @type {((inputs?: Enum_Link_Target_NavigationiframeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Link_Target_NavigationiframeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_link_target_navigationiframe(inputs)
	return de_enum_link_target_navigationiframe(inputs)
});